<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import ShowScheduleBlock from './../show/show-grid-block'
import { useAppearanceStore } from '@state/stores/appearance'

const INITIAL_RESOURCES = 30
const LOAD_MORE_THROTTLE_MS = 200
const BOTTOM_OFFSET_RATIO = 3

const props = defineProps({
    searchResults: {
        type: Object,
        default: () => {},
    },
    searchJoin: {
        type: Function,
        default: () => {},
    },
})

const appearanceStore = useAppearanceStore()

const visibleResources = ref(INITIAL_RESOURCES)
const shouldLoadMore = ref(true)

const shows = computed(() => props.searchResults.Shows)

const scroll = computed(() => appearanceStore.scroll)

function showMoreResults() {
    props.searchJoin(INITIAL_RESOURCES, visibleResources.value, 'Shows').then(remaining => {
        visibleResources.value = remaining
    })
}

watch(scroll, () => {
    if (shows.value.length < visibleResources.value) return

    const bottomOfWindow =
        scroll.value + window.innerHeight >=
        appearanceStore.scrollChild.offsetHeight - window.innerHeight / BOTTOM_OFFSET_RATIO

    if (bottomOfWindow && shouldLoadMore.value) {
        shouldLoadMore.value = false
        setTimeout(() => {
            shouldLoadMore.value = true
        }, LOAD_MORE_THROTTLE_MS)
        showMoreResults()
    }
})

onMounted(() => {
    visibleResources.value = shows.value.length
})
</script>

<template>
    <div>
        <BaseSection
            v-if="shows"
            padded
        >
            <ShowScheduleBlock :shows="shows" />
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
